import { FeatureFlag } from 'app/api/services/site-configs/types';
import { ConstantMenuItem } from 'app/modules/Navigation/types';

import { createActiveItemDetectionSelector } from 'app/modules/Navigation/selectors';
import { createConstantMenuItem } from 'app/modules/Navigation/utils';

import dictionary from './Service.dictionary.json';

const SERVICE_MENU_ITEMS: ConstantMenuItem[] = [
  createConstantMenuItem({
    key: 'personalData',
    label: dictionary.personalDataLabel,
    location: '/personal',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-personalData',
    },
  }),
  createConstantMenuItem({
    key: 'gifts',
    label: dictionary.giftsLabel,
    location: '/personal/gifts',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-gifts',
    },
  }),
  createConstantMenuItem({
    key: 'deposit',
    label: dictionary.depositLabel,
    location: '/personal/deposit',
    activeOn: 'prefix-match',
    dataGaValues: {
      ['data-ga-event']: 'depositStart',
      ['data-ga-event-value']: 'cabinetMenuClick',
    },
  }),
  createConstantMenuItem({
    key: 'withdrawal',
    label: dictionary.withdrawalLabel,
    location: '/personal/withdrawal',
    activeOn: 'prefix-match',
    dataGaValues: {
      ['data-ga-event']: 'cashoutStart',
      ['data-ga-event-value']: 'cabinetMenuClick',
    },
  }),
  createConstantMenuItem({
    key: 'active-stakes',
    label: dictionary.activeStakesLabel,
    location: '/personal/active-stakes',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-bidsView',
    },
  }),
  createConstantMenuItem({
    key: 'bet-history',
    label: dictionary.betHistoryLabel,
    location: '/personal/history-stakes',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-bidsHistory',
    },
  }),
  createConstantMenuItem({
    key: 'referral',
    label: dictionary.referralLabel,
    location: '/personal/history',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-accountHistory',
    },
  }),
  createConstantMenuItem({
    key: 'notifications',
    label: dictionary.notifications,
    location: '/personal/notifications',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profile-notifications-click',
    },
  }),
  createConstantMenuItem({
    key: 'cashback',
    label: dictionary.cashback,
    location: '/personal/cashback',
    activeOn: 'exact-match',
    ff: FeatureFlag.CASHBACK,
    dataGaValues: {
      ['data-ga-event']: 'profile-cashback-click',
    },
  }),
  createConstantMenuItem({
    key: 'preferences',
    label: dictionary.preferencesLabel,
    location: '/personal/profile',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'profileSettings',
      ['data-ga-event-value']: 'profileMenuClick',
    },
  }),
];

export const serviceMenuItemsWithPathname = (pathname: string) =>
  createActiveItemDetectionSelector(() => SERVICE_MENU_ITEMS, pathname);
